import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const getFollowUpTasks = async (params = {}) => {
  const response = await axios.get(`${API_URL}/follow-up-tasks`, {
    params,
    headers: getAuthHeader(),
  });
  return response.data;
};

export const getFollowUpTaskAssignees = async () => {
  const response = await axios.get(`${API_URL}/follow-up-tasks/assignees`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const createFollowUpTask = async (payload) => {
  const response = await axios.post(`${API_URL}/follow-up-tasks`, payload, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const updateFollowUpTask = async (taskId, payload) => {
  const response = await axios.put(`${API_URL}/follow-up-tasks/${taskId}`, payload, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const updateFollowUpTaskStatus = async (taskId, status) => {
  const response = await axios.put(`${API_URL}/follow-up-tasks/${taskId}/status`, { status }, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const logFollowUpTaskContact = async (taskId, payload) => {
  const response = await axios.post(`${API_URL}/follow-up-tasks/${taskId}/log-contact`, payload, {
    headers: getAuthHeader(),
  });
  return response.data;
};
